export enum SystemControlStatus {
  OFFLINE,
  ONLINE,
}

export namespace SystemControlStatus {
  let elements = [SystemControlStatus.OFFLINE, SystemControlStatus.ONLINE];
  let alias = "com.bcdfx.model.SystemControlStatus";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
